import { createSelector } from 'reselect';
import { getTolgeeInstance } from 'src/modules/config/selectors/getTolgeeInstance';
import { Translator } from 'src/modules/config/types/Translator';

export const getTranslator = createSelector([
  getTolgeeInstance,
], (tolgee): Translator => (key, values) => tolgee.t(key, values));
